import React, {useEffect, useState} from 'react';
import axios from "axios";

import {Select} from "@gravity-ui/uikit";

import {
    getJSONAcceptAuthConfig,
    getJSONConfig,
    REVIEW_PROJECTS_ENDPOINT,
    STREAMS_ENDPOINT,
    VENUES_ENDPOINT
} from '../../api/api';
import ProjectReviewCard from "../../components/projectCard/ProjectReviewCard";
import {STATUS_CHOICES} from "../../components/projectCard/utils";
import {UNALLOCATED_PROJECTS} from "../../utils/const";


function ProjectReviewList() {
    const [projects, setProjects] = useState([]);
    const [venues, setVenues] = useState([]);
    const [streams, setStreams] = useState([]);

    const [statusFilter, setStatusFilter] = useState([]);
    const [venueFilter, setVenueFilter] = useState([]);
    const [streamFilter, setStreamFilter] = useState('');
    const [curatorFilter, setCuratorFilter] = useState([]);
    const [schoolchildrenFilter, setSchoolchildrenFilter] = useState('');

    useEffect(() => {
        axios
            .get(REVIEW_PROJECTS_ENDPOINT, getJSONAcceptAuthConfig())
            .then(response => {
                setProjects(response.data);
            })
            .catch(error => {
                console.error('Error getting projects for review:', error);
            });

        axios
            .get(VENUES_ENDPOINT, getJSONConfig())
            .then(response => {
                setVenues(response.data);
            });

        axios
            .get(STREAMS_ENDPOINT, getJSONConfig())
            .then(response => {
                // Сортируем массив так, чтобы элемент "Нераспределенные проекты" был первым
                response.data.sort((a, b) => {
                    if (a.name === UNALLOCATED_PROJECTS) {
                        return -1;
                    } else if (b.name === UNALLOCATED_PROJECTS) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                setStreams(response.data);
            });
    }, []);

    const filterProjectsByStatus = () => {
        return projects.filter(project => {
            // Фильтрация по статусу
            if (statusFilter.length > 0 && !statusFilter.includes(project.status)) {
                return false;
            }

            // Фильтрация по площадке
            if (venueFilter.length > 0) {
                if (venueFilter.includes("-1")) {
                    if (project.venue && !venueFilter.includes(project.venue.id.toString())) {
                        return false; // Если площадка проекта не выбрана и в фильтре выбрана опция "Не выбрана"
                    }
                } else {
                    if (!project.venue || !venueFilter.includes(project.venue.id.toString())) {
                        return false; // Если площадка проекта не выбрана или не содержится в списке фильтра по площадке
                    }
                }
            }

            // Фильтрация по потоку
            if (streamFilter.length > 0) {
                if (!project.stream || !streamFilter.includes(project.stream.toString())) {
                    return false;
                }
            }

            // Фильтрация по наличию/отсутствию куратора
            if (curatorFilter.length > 0) {
                if (curatorFilter[0] === "with_curator" && (!project.managers || project.managers.length === 0)) {
                    return false;
                }
                if (curatorFilter[0] === "without_curator" && project.managers && project.managers.length > 0) {
                    return false;
                }
            }

            // Фильтрация по наличию или отсутствию школьных проектов
            if (schoolchildrenFilter.length > 0) {
                if (schoolchildrenFilter[0] === 'true' && !project.is_for_schoolchildren) {
                    return false;
                }
                if (schoolchildrenFilter[0] === 'false' && project.is_for_schoolchildren) {
                    return false;
                }
            }

            return true;
        });
    };

    return (
        <>
            <h3 className="mb-2">Поданные проекты</h3>
            <hr className="clearfix w-100 pb-0"/>

            <div className="project-filters">
                <div className="filters-column">
                    <div className="filter">
                        <label htmlFor="statusFilter">Статус:</label>
                        <Select id="statusFilter"
                                multiple={true}
                                hasClear
                                placeholder={'Все'}
                                onUpdate={(values) => setStatusFilter(values)}
                                renderOption={(option) => (
                                    <div style={{color: option.data.color}}>{option.children}</div>)}>
                            {Object.keys(STATUS_CHOICES).map((status) => (
                                <Select.Option key={status} value={status} data={{color: STATUS_CHOICES[status].color}}>
                                    {STATUS_CHOICES[status].label}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>

                    <div className="filter">
                        <label htmlFor="venueFilter">Площадка:</label>
                        <Select id="venueFilter"
                                multiple={true}
                                hasClear
                                placeholder={'Все'}
                            // value={user && !user.is_ws_director ? ['2'] : undefined} // TODO: доставать id управляемой площадки или id площадки потока
                            // disabled={user && !user.is_ws_director}
                                onUpdate={(values) => setVenueFilter(values)}>
                            <Select.Option value={"-1"}>Не выбрана</Select.Option>
                            {venues.map((venue) => (
                                <Select.Option key={venue.id}
                                               value={venue.id.toString()}>{venue.name}</Select.Option>
                            ))}
                        </Select>
                    </div>

                    <div className="filter">
                        <label htmlFor="streamFilter">Поток:</label>
                        <Select id="streamFilter"
                                multiple={true}
                                hasClear
                                placeholder={'Все'}
                            // value={user && !user.is_ws_director && !user.is_lws_director ? ['-1'] : undefined} // TODO: доставать id управляемого потока
                            // disabled={user && !user.is_ws_director && !user.is_lws_director}
                                onUpdate={(values) => setStreamFilter(values)}>
                            {streams.map((stream) => (
                                <Select.Option key={stream.id}
                                               value={stream.id.toString()}>{stream.name}</Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>

                <div className="filters-column">
                    <div className="filter">
                        <label htmlFor="curatorFilter">Наличие куратора:</label>
                        <Select id="curatorFilter"
                                hasClear
                                placeholder={'Все'}
                                onUpdate={(value) => setCuratorFilter(value)}>
                            <Select.Option value="with_curator">Есть куратор</Select.Option>
                            <Select.Option value="without_curator">Нет куратора</Select.Option>
                        </Select>
                    </div>

                    <div className="filter">
                        <label htmlFor="schoolchildrenFilter">Для школьников:</label>
                        <Select id="schoolchildrenFilter"
                                hasClear
                                placeholder={'Все'}
                                onUpdate={(values) => setSchoolchildrenFilter(values)}>
                            <Select.Option value="true">Да</Select.Option>
                            <Select.Option value="false">Нет</Select.Option>
                        </Select>
                    </div>
                </div>
            </div>

            {filterProjectsByStatus().map((project) => (
                <ProjectReviewCard key={"PRC" + project.id} project={project}/>
            ))}
        </>
    );
}

export default ProjectReviewList;